import validate from "/tmp/build_ace96276/node_modules/nuxt/dist/pages/runtime/validate.js";
import toggles_45global from "/tmp/build_ace96276/src/middleware/toggles.global.js";
import manifest_45route_45rule from "/tmp/build_ace96276/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  toggles_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}